var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPosts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#58CA6B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.764 12C46.76 12 50 15.2727 50 19.3091V44.6909C50 48.7273 46.76 52 42.764 52H21.236C19.3169 52 17.4764 51.2299 16.1194 49.8592C14.7624 48.4885 14 46.6294 14 44.6909V19.3091C14 15.2727 17.24 12 21.236 12H42.764ZM42.782 15.6364H21.218C19.22 15.6364 17.6 17.2727 17.6 19.2909V44.7091C17.6 46.7273 19.22 48.3636 21.218 48.3636H42.782C44.78 48.3636 46.4 46.7273 46.4 44.7091V19.2909C46.4 17.2727 44.78 15.6364 42.782 15.6364ZM40.991 26.5455C41.99 26.5455 42.8 27.3636 42.8 28.3727V42.9C42.8 43.9091 41.99 44.7273 40.991 44.7273H23.009C22.01 44.7273 21.2 43.9091 21.2 42.9V28.3727C21.2 27.3636 22.01 26.5455 23.009 26.5455H40.991ZM33.8 19.2727C34.2774 19.2727 34.7352 19.4643 35.0728 19.8053C35.4104 20.1462 35.6 20.6087 35.6 21.0909C35.6 21.5731 35.4104 22.0356 35.0728 22.3766C34.7352 22.7175 34.2774 22.9091 33.8 22.9091H23C22.5226 22.9091 22.0648 22.7175 21.7272 22.3766C21.3896 22.0356 21.2 21.5731 21.2 21.0909C21.2 20.6087 21.3896 20.1462 21.7272 19.8053C22.0648 19.4643 22.5226 19.2727 23 19.2727H33.8Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosts);
export default __webpack_public_path__ + "static/media/posts.83fa6a4cb71173de4bd6429653bf23bf.svg";
export { ForwardRef as ReactComponent };